import { RouterView } from 'vue-router';
import advertisingRoutes from './publicity/advertising.routes';
import assetRoutes from './publicity/assets.routes';
import campaignRoutes from './publicity/campaigns.routes';
import contractRoutes from './publicity/contracts.routes';
import firstContactsRoutes from './publicity/firstContacts.routes';
import influencerRoutes from './publicity/influencers.routes';
import leadRoutes from './publicity/leads.routes';
import customerSourceRoutes from './publicity/sources.routes';
import tutorialRoutes from './publicity/tutorials.routes';

const publicityRoutes = [
    {
        path: 'publicity',
        name: 'Publicity',
        redirect: () => {
            return { path: '/publicity/leads' };
        },
        component: RouterView,
        meta: {
            title: 'Publicity',
            public: false,
            icon: 'SparklesIcon',
        },
        children: [
            ...leadRoutes,
            ...advertisingRoutes,
            ...firstContactsRoutes,
            ...customerSourceRoutes,
            ...influencerRoutes,
            ...assetRoutes,
            ...contractRoutes,
            ...campaignRoutes,
            ...tutorialRoutes,
        ],
    },
];

export default publicityRoutes;
